import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { AppConfig, APP_CONFIG } from './app/shared/services/config-initialization.service';
import { environment } from './environments/environment';
import appConfigData from './app-config.json';

const localConfig: AppConfig = appConfigData as AppConfig;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic([{ provide: APP_CONFIG, useValue: localConfig }])
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
